// InputField.js
import React, {useContext, useState} from 'react';
import DocumentAuthorContext from '../../../../../context/DocumentAuthorContext';
import ApplicationContext from '../../../../../context/ApplicationContext';

function InputField({ component, view }) {
    const { componentAnswers } = useContext(DocumentAuthorContext);
    return (
        <div className={`${component?.label?.alignment === 'top' ? 'flex flex-col' : component?.label?.alignment === 'right' ? 'flex flex-row-reverse' :
            component?.label?.alignment === 'bottom' ? 'flex flex-col-reverse text-center mt-1' : 'flex items-center'} cursor-default`}>
            {component.label.name.trim() !== '' && 
            <label className={`cursor-default pr-2 break-all`} style={component?.label?.styles}>
                {component.label.name || ''} {component.is_required && <span data-testid="is_required" className='text-[#333]'>*</span>}
            </label>}
            <input
                id={component.id}
                className={`forms-authoring-input bg-transparent max-w-[800px]`}
                value={componentAnswers[component.component_id] || component?.value}
                style={component?.styles}
                type={component?.properties?.inputType === 'date' || component?.properties?.inputType === undefined ? 'text' : component?.properties?.inputType}
                placeholder={component?.placeholder?.name || ''}
            />
        </div>
    );
}

export default InputField;
